import React, { PureComponent } from 'react';
import { Root } from './Dashboard.css';
import { withRouter } from 'react-router-dom';
import * as echarts from 'echarts';
import instance from '../../request/http';
import { globalData } from '../../common/common';
import LetterAvatar from '../Components/LetterAvatar';
import { BASE_URL } from '../../store/config';
import { Grid, MenuItem, Table, TableBody, TableCell, TableHead, TableRow, TextField } from '@material-ui/core';
import Weather from './Components/Weather'
import Toast from "../Layout/components/Toast";
import { cutString, getUTCTimestamp } from "../../common/utils"
import userDao from '../../request/userDao';

class Dashboard extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            overallDate: 'Monthly',
            overall: {
                amount_billable_hours: '-',
                amount_case: '-',
                amount_client: '-',
                amount_invoice: '-',
            },
            matters: [],
            timesheets: [],
            members: [],
            showToast: false,
            toastMsg: "",
            toastState: "",
        };
        this.menuHandler = this.menuHandler.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
    }

    render() {
        const {
            username,
            overallDate,
            overall,
            matters,
            timesheets,
            members,
            showToast,
            toastMsg,
            toastState,
        } = this.state,
            greeting = () => {
                const curHr = new Date().getHours();

                if (curHr < 12) {
                    return 'Good morning';
                }
                if (curHr < 17) {
                    return 'Good afternoon';
                }
                return 'Good evening';
            };
        // const managerView = (arr) => {
        //     if (arr.length !== 0) {
        //         return <div className="flow">
        //             {arr.map(item => (
        //                 <div key={item.id} className="member c">
        //                     <LetterAvatar name={item.first_name + ' ' + item.last_name} />
        //                     <div className="m-name">{item.first_name + ' ' + item.last_name}</div>
        //                     <div className="m-job">Department Manager</div>
        //                 </div>
        //             ))}
        //         </div>
        //     }
        // }
        const membersView = (arr) => {
            if (arr.length !== 0) {
                return <div className="flow">
                    {arr[0].map(item => (
                        <div key={item.id} className="member c">
                            <LetterAvatar name={item.first_name + ' ' + item.last_name} />
                            <div className="m-name">{item.first_name + ' ' + item.last_name}</div>
                            <div className="m-job">{item.position ? item.position : ''}</div>
                        </div>
                    ))}
                </div>
            }
        }     
        return (
        
            <Root>
                <div className="content">
                    <div className="title">{greeting()}, {username}</div>
                    <div className="subtitle">What would you like to do today?</div>
                    <ul className="menu h">
                        <li className="menu-item c" onClick={e => this.menuHandler(e, "/main/invoicecreate")}>
                            <img alt="" src={require('../../assets/dashboard-1.png')} />
                            <div>Create a<br />Invoice</div>
                        </li>
                        <li className="menu-item c" onClick={e => this.menuHandler(e, "/main/timesheet")}>
                            <img alt="" src={require('../../assets/dashboard-2.png')} />
                            <div>Create a<br />Timesheet</div>
                        </li>
                        <li className="menu-item c" onClick={e => this.menuHandler(e, "/main/case")}>
                            <img alt="" src={require('../../assets/dashboard-3.png')} />
                            <div>Create a<br />Case</div>
                        </li>
                        <li className="menu-item c" onClick={e => this.menuHandler(e, "/main/matter")}>
                            <img alt="" src={require('../../assets/dashboard-4.png')} />
                            <div>Create a<br />Matter</div>
                        </li>
                        <li className="menu-item c" onClick={e => this.menuHandler(e, "/main/addclient")}>
                            <img alt="" src={require('../../assets/dashboard-5.png')} />
                            <div>Add a<br />New Client</div>
                        </li>
                        <li className="menu-item c" onClick={e => this.menuHandler(e, "/main/myprofile")}>
                            <img alt="" src={require('../../assets/dashboard-6.png')} />
                            <div>Edit My<br />Profiles</div>
                        </li>
                    </ul>
                    <Grid container spacing={3}>
                        <Grid item container spacing={3}>
                            <Grid item xs={7}>
                                <div className="panel panel-0">
                                    <div className="panel-title h">LOCAL WEATHER</div>
                                    <div className="panel-content">
                                        <Weather />
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={5}>
                                <div className="panel panel-1">
                                    <div className="panel-title h">OVERALL STATS</div>
                                    <div className="panel-content">
                                        <TextField select
                                            className="select" value={overallDate}
                                            onChange={e => this.handleChange(e, 'overallDate')}
                                            margin="dense" variant="outlined">
                                            <MenuItem key="Monthly" value="Monthly">Monthly</MenuItem>
                                            <MenuItem key="Daily" value="Daily">Daily</MenuItem>
                                            <MenuItem key="Weekly" value="Weekly">Weekly</MenuItem>
                                        </TextField>
                                        <div className="row row1 h">
                                            <div className="col f h">
                                                <img alt="" src={require("../../assets/dashboard-7")} />
                                                <div>
                                                    <div className="col-value">{overall.amount_client}</div>
                                                    <div>Total New Clients</div>
                                                </div>
                                            </div>
                                            <div className="col-gap"></div>
                                            <div className="col f h">
                                                <img alt="" src={require("../../assets/dashboard-8")} />
                                                <div>
                                                    <div className="col-value">{overall.amount_case}</div>
                                                    <div>Total New Cases</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row row2 h">
                                            <div className="col f h">
                                                <img alt="" src={require('../../assets/dashboard-9')} />
                                                <div>
                                                    <div className="col-value">{overall.amount_billable_hours}</div>
                                                    <div>Total Billable hours</div>
                                                </div>
                                            </div>
                                            <div className="col-gap"></div>
                                            <div className="col f h">
                                                <img alt="" src={require('../../assets/dashboard-10')} />
                                                <div>
                                                    <div className="col-value">{overall.amount_invoice}</div>
                                                    <div>Total Completed Invoices</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={4}>
                                <div className="panel panel-2">
                                    <div className="panel-title h">MY INVOICE STATS</div>
                                    <div className="panel-content">
                                        <div className="invoice-chart"></div>
                                        <div className="more h hr"
                                            onClick={e => this.menuHandler(e, "/main/invoicelist")}>See All Invoices
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={4}>
                                <div className="panel panel-3">
                                    <div className="panel-title h">MY WEEKLY TIMESHEET STATS</div>
                                    <div className="panel-content">
                                        <div className="timesheet-chart"></div>
                                        <div className="more h hr"
                                            onClick={e => this.menuHandler(e, "/main/timesheet")}>See
                                            All Timesheet
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={4}>
                                <div className="panel panel-4">
                                    <div className="panel-title h">MY REFERRAL STATS</div>
                                    <div className="panel-content">
                                        <div className="referral-chart"></div>
                                        <div className="more h hr"
                                            onClick={e => this.menuHandler(e, "/main/referral", "?tab_index=0&page_index=1&page_size=5")}>See
                                            All Referrals
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                        <Grid item container spacing={3}>
                            <Grid item xs={6}>
                                <div className="panel panel-5">
                                    <div className="panel-title h">MY RECENT MATTERS</div>
                                    <div className="panel-content">
                                        <Table stickyHeader className="table">
                                            <TableHead>
                                                <TableRow role="checkbox">
                                                    <TableCell style={{ minWidth: '100px' }}>Case No.</TableCell>
                                                    <TableCell>Matter</TableCell>
                                                    <TableCell>Client</TableCell>
                                                    <TableCell>Note</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {matters.map(row => (
                                                    <TableRow key={row.id} role="checkbox">
                                                        <TableCell component="th" scope="row">
                                                            {cutString(row.caseNumber)}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            {cutString(row.name)}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            {cutString(row.client)}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            {cutString(row.note)}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        <div className="more h hr" onClick={e => this.menuHandler(e, "/main/case")}>See
                                        All Matters
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={6}>
                                <div className="panel panel-6">
                                    <div className="panel-title h">TODAY’S TIMESHEET</div>
                                    <div className="panel-content">
                                        <Table stickyHeader className="table">
                                            <TableHead>
                                                <TableRow role="checkbox" className="thead">
                                                    <TableCell>Case No.</TableCell>
                                                    <TableCell>Matter</TableCell>
                                                    <TableCell>Note</TableCell>
                                                    <TableCell>Task Type</TableCell>
                                                    <TableCell>Hours</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {timesheets.map(row => (
                                                    <TableRow key={row.id} role="checkbox">
                                                        <TableCell component="th" scope="row">
                                                            {cutString(row.caseNumber)}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            {cutString(row.matter)}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            {cutString(row.note)}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            {cutString(row.type)}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            {cutString(row.hours)}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        <div className="more h hr"
                                            onClick={e => this.menuHandler(e, "/main/timesheet")}>+
                                            Add a New Timesheet
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                        <Grid item container spacing={3}>
                            <Grid item xs={12}>
                                <div className="panel panel-7">
                                    <div className="panel-title h">DEPARTMENT MEMBERS</div>
                                    <div className="panel-content">
                                        {members.map((item, index) => (
                                            <div className="h h-c" key={index}>
                                                {/* {managerView(item.manager)} */}
                                                {/* <div className="line"></div> */}
                                                {membersView(item.members)}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
            </Root>
        );
    }

    componentDidMount() {
        userDao.getUserInfo((userInfo) => {
            globalData.userInfo = userInfo;
            this.setState(() => ({
                username: userInfo.first_name
            }));
            this.getOverAll();
            this.getInvoices();
            this.getTimesheet();
            this.getMatters();
            this.getReferral();
            this.getMembers();
        });
    }

    drawReferralChart(data) {
        var referralChart = echarts.init(document.querySelector(".referral-chart"));
        var option = {
            tooltip: {
                trigger: 'item',
                formatter: '{b}:<br/>{c} ({d}%)'
            },
            series: [
                {
                    type: 'pie',
                    radius: '80%',
                    center: ['50%', '55%'],
                    data: data.sort(function (a, b) {
                        return a.value - b.value;
                    }),
                    roseType: 'radius',
                    animationType: 'scale',
                    animationEasing: 'elasticOut',
                    animationDelay: function (idx) {
                        return Math.random() * 200;
                    }
                }
            ]
        };
        referralChart.setOption(option);
    }

    drawInvoiceChart(data) {
        var invoiceChart = echarts.init(document.querySelector(".invoice-chart"));
        var option = {
            tooltip: {
                trigger: 'item',
                formatter: '{b}: <br/> {c} ({d}%)'
            },
            series: [
                {
                    name: 'Invoices',
                    type: 'pie',
                    radius: ['40%', '70%'],
                    center: ['50%', '50%'],
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    },
                    data
                }
            ]
        };
        invoiceChart.setOption(option);
    }

    drawTimesheetChart(xData, yDatas) {
        var timesheetChart = echarts.init(document.querySelector(".timesheet-chart"));
        var option = {
            tooltip: {
                trigger: 'axis',
                axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                    type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                }
            },
            color: ['#18C6FF', '#f55a45'],
            legend: {
                data: ['Admin Hour', 'Billable Hour']
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: [
                {
                    type: 'category',
                    data: xData
                }
            ],
            yAxis: [
                {
                    type: 'value'
                }
            ],
            series: [
                {
                    name: 'Admin Hour',
                    type: 'bar',
                    stack: 'total',
                    barWidth: 20,
                    data: yDatas[0]
                },
                {
                    name: 'Billable Hour',
                    type: 'bar',
                    stack: 'total',
                    barWidth: 20,
                    data: yDatas[1]
                }
            ]
        };
        timesheetChart.setOption(option);
    }

    transferDate(date, begin) {
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (day >= 0 && day <= 9) {
            day = "0" + day;
        }
        var dateString = year + '/' + month + '/' + day + ' 23:59:59';
        if (begin) {
            dateString = year + '/' + month + '/' + day + ' 00:00:00';
        }
        var newDate = new Date(dateString);
        return newDate.getTime() / 1000;
    }

    getMonth() {
        var startDate = new Date();
        startDate.setDate(1);
        var date = new Date();
        var currentMonth = date.getMonth();
        var nextMonth = ++currentMonth;
        var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
        var oneDay = 1000 * 60 * 60 * 24;
        var endDate = new Date(nextMonthFirstDay - oneDay);
        let s = this.transferDate(startDate, true);
        let e = this.transferDate(endDate);
        return [s, e];
    }

    getNowDate() {
        var date = new Date();
        let s = this.transferDate(date, true);
        let e = this.transferDate(date);
        return [s, e];
    }

    getWeek() {
        //按周日为一周的最后一天计算
        var date = new Date();
        //今天是这周的第几天
        var today = date.getDay();
        //上周日距离今天的天数（负数表示）
        var stepSunDay = -today + 1;
        // 如果今天是周日  
        if (today === 0) {
            stepSunDay = -7;
        }
        // 周一距离今天的天数（负数表示）  
        var stepMonday = 7 - today;
        var time = date.getTime();
        var monday = new Date(time + stepSunDay * 24 * 3600 * 1000);
        var sunday = new Date(time + stepMonday * 24 * 3600 * 1000);
        //本周一的日期 （起始日期）
        var startDate = this.transferDate(monday, true); // 日期变换
        //本周日的日期 （结束日期）
        var endDate = this.transferDate(sunday); // 日期变换
        return [startDate, endDate];
    }

    getJMD(num) {
        let now = new Date();
        if (num > 0) {
            now = now.setDate(now.getDate() - num);
            now = new Date(now);
        }
        let m = now.getMonth() + 1;
        let d = now.getDate();
        return (m < 10 ? '0' + m : m) + "/" + (d < 10 ? '0' + d : d);
    }

    getOverAll() {
        let time = [];
        if (this.state.overallDate === "Weekly") {
            time = this.getWeek();
        } else if (this.state.overallDate === "Monthly") {
            time = this.getMonth();
        } else if (this.state.overallDate === "Daily") {
            time = this.getNowDate();
        }
        let userInfo = globalData.userInfo;
        const params = {
            start_time: time[0],
            end_time: time[1],
            user_id: userInfo.id
        }
        instance.get(BASE_URL + 'dashboard/overall', { params }).then((res) => {
            let resData = res.data.data;
            this.setState(() => ({
                overall: {
                    amount_billable_hours: parseInt(resData.amount_billable_hours / 60 / 60),
                    amount_case: resData.amount_case,
                    amount_client: resData.amount_client,
                    amount_invoice: resData.amount_invoice
                }
            }))
        }).catch((err) => {
            const msg = err.response.data.message;
            console.log(msg);
        })
    }

    getInvoices() {
        let userInfo = globalData.userInfo;
        const params = {
            user_id: userInfo.id
        }
        instance.get(BASE_URL + 'dashboard/invoices', { params }).then((res) => {
            let resData = [
                { value: res.data.data.editing, name: 'Edting', itemStyle: { color: "#18C6FF" } },
                { value: res.data.data.sent, name: 'Sent', itemStyle: { color: "#fcba03" } },
                { value: res.data.data.complete, name: 'Completed', itemStyle: { color: "#43D79E" } }
            ]
            this.drawInvoiceChart(resData)
        }).catch((err) => {
            // const msg = err.response.data.message;
        })
    }

    getTimesheet() {
        const params = {
            date: getUTCTimestamp(),
        };
        instance.get(BASE_URL + 'dashboard/timesheet', { params }).then((res) => {
            console.log(res);
            let x = []
            for (let i = 0; i < 7; i++) {
                let d = this.getJMD(i);
                x.push(d);
            }
            x.reverse();
            let a = [];
            let h = (value, isAdmin) => {
                return {
                    value: (value === 0 ? 0 : parseInt(value / 60 / 60)),
                    itemStyle: {
                        color: isAdmin ? '#18C6FF' : '#f55a45'
                    }
                }
            };

            a.push(h(res.data.data.pre_6day.Admin, true));
            a.push(h(res.data.data.pre_5day.Admin, true));
            a.push(h(res.data.data.pre_4day.Admin, true));
            a.push(h(res.data.data.pre_3day.Admin, true));
            a.push(h(res.data.data.pre_2day.Admin, true));
            a.push(h(res.data.data.pre_1day.Admin, true));
            a.push(h(res.data.data.today.Admin, true));
            let b = [];
            b.push(h(res.data.data.pre_6day.Billable, false));
            b.push(h(res.data.data.pre_5day.Billable, false));
            b.push(h(res.data.data.pre_4day.Billable, false));
            b.push(h(res.data.data.pre_3day.Billable, false));
            b.push(h(res.data.data.pre_2day.Billable, false));
            b.push(h(res.data.data.pre_1day.Billable, false));
            b.push(h(res.data.data.today.Billable, false));
            this.drawTimesheetChart(x, [a, b]);

            let todays = res.data.data.today_list;
            let timesheets = [];
            todays.forEach((item) => {
                console.log(item);
                var v = {
                    id: item.id,
                    note: item.note,
                    type: item.hours_type,
                    hours: parseInt(item.hours) / 60 / 60
                }
                if (item.matter && item.matter.length > 0) {
                    v.matter = item.matter[0].name;
                    v.caseNumber = item.matter[0].case.number;
                } else {
                    v.matter = '--';
                    v.caseNumber = '--';
                }
                timesheets.push(v);
            });
            this.setState(() => ({
                timesheets
            }));
        }).catch((err) => {
            if (!err.response) {
                console.error(err);
                return;
            }
            // const msg = err.response.data.message;
        })
    }

    getMatters() {
        instance.get(BASE_URL + 'dashboard/matters').then((res) => {
            let resDatas = res.data.data;
            let matters = [];
            resDatas.forEach((item) => {
                console.log(item);
                let clientName = "";
                if (item.case.client.individual) {
                    clientName = item.case.client.individual.first_name + " " + item.case.client.individual.last_name;
                } else if (item.case.client.corporation) {
                    clientName = item.case.client.corporation.name;
                }

                let v = {
                    caseNumber: item.case.number,
                    id: item.id,
                    number: item.number,
                    name: item.name,
                    note: item.note,
                    client: clientName,
                };
                matters.push(v);
            });
            this.setState(() => ({
                matters
            }))

        }).catch((err) => {
            if (!err.response) {
                console.error(err);
                return;
            }
            // const msg = err.response.data.message;
        })
    }

    getReferral() {
        instance.get(BASE_URL + 'dashboard/referral').then((res) => {
            let resData = res.data.data;
            let referrals = [];
            referrals.push({ name: "Completed", value: resData.completed, itemStyle: { color: "#43D79E" } });
            referrals.push({ name: "Paid", value: resData.paid, itemStyle: { color: "#f55a45" } });
            referrals.push({ name: "Passed", value: resData.passed, itemStyle: { color: "#C1C0C2" } });
            referrals.push({ name: "Referral", value: resData.referral, itemStyle: { color: "#18C6FF" } });
            referrals.push({ name: "Signed", value: resData.signed, itemStyle: { color: "#fcba03" } });
            this.drawReferralChart(referrals);

        }).catch((err) => {
            if (!err.response) {
                console.error(err);
                return;
            }
            // const msg = err.response.data.message;
        })
    }

    getMembers() {
        instance.get(BASE_URL + 'dashboard/members').then((res) => {
            let resData = res.data.data;
            console.log("resDataresDataresDataresDataresData", resData)
            // let members = [];
            // resData.forEach((item) => {
            //     let v = {
            //         id: item.id,
            //         name: item.first_name + ' ' + item.last_name,
            //         position: item.position
            //     }
            //     members.push(v);
            // })
            this.setState(() => ({
                members: resData
            }))
        }).catch((err) => {
            if (!err.response) {
                console.error(err);
                return;
            }
            // const msg = err.response.data.message;
        })
    }

    //组件即将被剔除执行
    componentWillUnmount() {
    }

    menuHandler(e, name, search = "") {
        this.props.history.push({
            pathname: name,
            search: search,
        });
    }

    handleChange(e, name) {
        const value = e.target.value;
        this.setState(
            () => ({
                [name]: value
            }),
            () => {
                if (name === "overallDate") {
                    this.getOverAll();
                }
            }
        )
    }

    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }

    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
}

export default withRouter(Dashboard);